import { Map, Marker, Popup, setWorkerUrl } from "maplibre-gl";
import maplibreWorkerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

import { applySafeMapRemove } from "./maplibre-gl.safe-remove";

let isMapLibreGlInitialized = false;

/**
 * MapLibre GL JS v6 is ESM-only; Vite/IIFE builds must point the worker at a bundled asset URL
 * (`import.meta.url` is stubbed in our single-bundle IIFE output).
 *
 * Use `?worker&url`, not `?url`: the dist worker imports `maplibre-gl-shared.mjs`, and plain
 * `?url` emits the worker verbatim without that sibling — the worker dies on first import
 * (GeoJSON line layers vanish; raster tiles and HTML markers still render). Dev mode masks this.
 */
export const initMapLibreGl = (): void => {
  if (isMapLibreGlInitialized) {
    return;
  }

  setWorkerUrl(maplibreWorkerUrl);
  applySafeMapRemove(Map.prototype);
  applySafeMapRemove(Marker.prototype);
  applySafeMapRemove(Popup.prototype);
  isMapLibreGlInitialized = true;
};
